/**
 * Il CIN, Codice Identificativo Nazionale delle strutture ricettive.
 *
 * Guesty non lo espone — nei permessi dell'annuncio c'è solo lo stato della
 * registrazione, non il codice — quindi lo dice l'host e lo tiene Otto. Che lo
 * dica dalla scheda immobile o scrivendolo in chat, la regola per riconoscerlo
 * deve essere una sola: due validazioni diverse sullo stesso dato finiscono
 * sempre per accettare cose diverse, e il giorno che succede nessuno sa quale
 * delle due ha ragione.
 *
 * Formato: `IT` più il codice ISTAT del comune e una parte alfanumerica, 18
 * caratteri in tutto. L'intervallo è tenuto largo di proposito: è meglio
 * accettare un codice valido di una lunghezza che non ci aspettavamo che
 * rifiutarlo, perché l'host lo legge da un portale e non ha modo di
 * discutere con noi.
 */

import { z } from "zod";

/**
 * Toglie spazi e trattini e porta in maiuscolo.
 *
 * Un CIN si copia da un portale o si legge da un foglio, e arriva spaziato
 * («IT 001272 B4XYZ123AB») o in minuscolo. Rifiutarlo per questo sarebbe
 * pignoleria a spese di chi lo sta inserendo.
 */
export function normalizzaCin(grezzo: string): string {
  return grezzo.replace(/[\s-]/g, "").toUpperCase();
}

export const MOTIVO_CIN_NON_VALIDO =
  "Un CIN comincia con IT ed è lungo 18 caratteri, lettere e numeri";

export const CinSchema = z
  .string()
  .transform(normalizzaCin)
  .refine((v) => /^IT[0-9A-Z]{14,20}$/.test(v), MOTIVO_CIN_NON_VALIDO);

/** `true` se questa stringa può essere un CIN. Non dice se è *quello giusto*. */
export function eCinPlausibile(grezzo: string): boolean {
  return /^IT[0-9A-Z]{14,20}$/.test(normalizzaCin(grezzo));
}
